<h2 mat-dialog-title>{{ headerText() }}</h2>
<mat-dialog-content>
  {{ data.itemType }} <span class="name">{{ data.name }}</span> wirklich löschen?
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button (click)="abort()" cdkFocusInitial>Nein</button>
  <button mat-raised-button (click)="deleteEntry()">Ja</button>
</mat-dialog-actions>